export enum ExtraItemsQuickAction {
  ADD_ITEMS = 'ADD_ITEMS',
  PAYMENT = 'PAYMENT',
}
